function getMqttConfiguration() {
    return fetch('/api/mqttconfig').then(function(response) {
        return response.json();
    }).then(function(data) {
        return data;
    });
}

const AppConfigService = { getMqttConfiguration};
export default AppConfigService;